<template>
	<v-stepper alt-labels v-model="step">
		<v-stepper-header>
			<v-stepper-step step="1" :complete="step > 1" class="text-center">
				{{ $t("title.restaurant") }}
			</v-stepper-step>

			<v-divider></v-divider>

			<v-stepper-step
				step="2"
				:complete="step > 2"
				class="text-center align-center"
				text-center
				style="text-align: center"
			>
				{{ $t("title.outlet") }}
			</v-stepper-step>

			<v-divider></v-divider>

			<v-stepper-step step="3" :complete="step > 3" class="text-center">
				{{ $t("title.detail") }}
			</v-stepper-step>

			<v-divider></v-divider>

			<v-stepper-step step="4">
				{{ $t("title.completed") }}
			</v-stepper-step>
		</v-stepper-header>
	</v-stepper>
</template>

<script>
export default {
	props: ["step", "outlet"],
};
</script>